import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { environment } from '../../environments/environment';

@Injectable()
export class AuthGuardService  {

    constructor(private router: Router) { }

    canActivate (route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): boolean {
        if (!environment.enableUTF) {
            this.router.navigateByUrl('/page-not-found');
        }
        return environment.enableUTF;
    }
}
